"use client";

import React, { useEffect } from "react";
import "./ConstructionUpdateNew.css";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

import Image from "next/image";
import { motion } from "framer-motion";

function ConstructionUpdateNew({ projectDetail }) {
  const constructionInfo = projectDetail?.construction_data_2;

  const progress = Number(constructionInfo?.progress_percent);

  const images = projectDetail?.construction_data?.image || [];
  const scaleFadeVariant = {
    hidden: {
      opacity: 0,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };
  useEffect(() => {
    Fancybox.bind("[data-fancybox='construction']", {
      Thumbs: false,

      Toolbar: {
        display: ["close"],
      },
    });

    return () => {
      Fancybox.unbind("[data-fancybox='construction']");
    };
  }, []);

  if (!images.length) return null;

  const visibleImages = images.slice(0, 2);

  const getImage = (url, w, h) => {
    if (!url) return "";

    const separator = url.includes("?") ? "&" : "?";

    return `${url}${separator}w=${w}&h=${h}&q=100`;
  };

  return (
    <section className="construction-section section-padding">
      <div className="main-container-fluid">
        <div className="section-title">
          <h2>{constructionInfo?.title || "Construction Update"}</h2>
        </div>

        <div className="construction-grid">
          {visibleImages.map((item, index) => (
            <motion.a
              key={index}
              href={item.image_main}
              data-fancybox="construction"
              className="construction-card"
              initial="hidden"
              whileInView="visible"
              viewport={{
                once: true,
                amount: 0.25,
              }}
              variants={scaleFadeVariant}
              transition={{
                duration: 0.8,
                ease: "easeOut",
                delay: index * 0.1,
              }}
            >
              <div className="construction-image">
                <Image
                  fill
                  priority={index === 0}
                  quality={100}
                  alt={`construction-${index}`}
                  src={getImage(item.image, 1200, 800)}
                  className="object-cover"
                  sizes="
                    (max-width:768px)
                    100vw,
                    50vw
                    "
                />

                {/* only second image gets progress */}

                {index === 1 && (
                  <div className="construction-progress">
                    <svg viewBox="0 0 36 36">
                      <path
                        className="track"
                        d="
M18 2
a16 16 0 1 1 0 32
a16 16 0 1 1 0 -32
"
                      />

                      <path
                        className="progress"
                        strokeDasharray={`${progress},100`}
                        d="
M18 2
a16 16 0 1 1 0 32
a16 16 0 1 1 0 -32
"
                      />
                    </svg>

                    <div>
                      <strong>{progress}%</strong>

                      <span>{item.construction_date}</span>
                    </div>
                  </div>
                )}
              </div>
            </motion.a>
          ))}
        </div>

        {/* hidden fancybox loop */}

        <div
          style={{
            display: "none",
          }}
        >
          {images.map((item, index) => (
            <a
              key={index}
              href={item.image_main}
              data-fancybox="construction"
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ConstructionUpdateNew;
